var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.214,
    height: 18.916,
    viewBox: "0 0 16.214 18.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "license",
    "data-name": "license",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M19.741,4.778l-7.431-2.7a.577.577,0,0,0-.473,0l-7.431,2.7A.684.684,0,0,0,4,5.386v5.4c0,5.607,2.973,7.3,7.026,9.593l.743.405a.372.372,0,0,0,.338.135.609.609,0,0,0,.338-.068l.743-.405c4.053-2.365,7.026-4.053,7.026-9.593V5.386A.649.649,0,0,0,19.741,4.778Z",
    transform: "translate(0 -0.008)",
    fill: "#a0a5db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M11.9,2.068,4.473,4.77A.649.649,0,0,0,4,5.378v5.4c0,5.607,2.973,7.3,7.026,9.593l.743.405a.406.406,0,0,0,.27.068V2C11.972,2,11.9,2,11.9,2.068Z",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M20.214,10.791v-5.4a.649.649,0,0,0-.473-.608l-7.431-2.7a.577.577,0,0,0-.473,0l-7.431,2.7A.684.684,0,0,0,4,5.386v6.08H20.214Z",
    transform: "translate(0 -0.008)",
    fill: "#a0a5db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M23.634,4.77,16.2,2.068A.248.248,0,0,0,16,2v9.458h8.107V5.378A.649.649,0,0,0,23.634,4.77Z",
    transform: "translate(-3.893)",
    fill: "#303aa2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.d1a10ef1bff462cc870a1eb889acc465.svg";
export { ForwardRef as ReactComponent };